import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import Brands from "./Brands";
import CategoriesList from './CategoriesList';
import TagManagerService from 'services/TagManager';
import Specification from "./Specification";
import style from './style.scss'; //NOSONAR

let actions = [];
let specificationSelected = [];

const Sidebar = (props) => {
    const filters = props.filters ? props.filters : '';
    const [isFilterOpened, setIsFilterOpened] = useState(false);
    const [brandName, setBrandName] = useState([]);
    const [specificationName, setSpecificationName] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState(false);


    const onToogleFilter = (payload) => {
        setIsFilterOpened(payload.value.isFilterOpened || false);
    }

    const closeFilter = () => {
        setIsFilterOpened(false);
    }

    useEffect(() => {
        actions.push(PubSub.register('catalog_toogleFilter', onToogleFilter));
        actions.push(PubSub.register('filter_brandSelected', getBrandsSelected));
        actions.push(PubSub.register('filter_specificationSelected', getSpecificationSelected));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [])

    const getBrandsSelected = (payload) => {
        if(!(payload && payload.value)) return '';

        filters.brands = payload.value.brands;
        verifyBtn();
    }

    const getSpecificationSelected = (payload) => {
        if(!(payload && payload.value)) return '';
        const filtersData = filters.filtersSearch || filters.filters;
        specificationSelected = Object.keys(filtersData).reduce((acumulator, specification) =>  {
            return acumulator.concat(filtersData[specification].filter(item => item.active || item.checked))
        },[])

        setSpecificationName(specificationSelected.map((item) => ({name: item.Name})));
        verifyBtn();
    }


    const getFiltersSearch = (filtersSearch, isSearch = true) => {
        let results = [];

        if(!filtersSearch) return results;

        for(const key in filtersSearch){
            if(isSearch){
                filtersSearch[key] = filtersSearch[key].map((item)=> {
                    item.id = key;
                    return item;
                });
            }
            results.push({
                name: key,
                items: filtersSearch[key]
            })
        }

        return results;
    };

    const cleanFilters = (event) => {
        event.preventDefault();
        filters.brands = filters.brands.map(brand => {
            brand.active = false;
            brand.checked = false;
            return brand
        })

        specificationSelected = specificationSelected.map(item => {
            item.active = false;
            item.checked = false;
            return item;
        });
        setBrandName([]);
        setSpecificationName([]);
        PubSub.dispatch('filter_setBrands', { brands: [] });
        PubSub.dispatch('filter_setSpecifications', { specifications: []});
    }

    const cleanFilter = (event, filter, type) => {
        event.preventDefault();
        if(type === 'brand') {
            filters.brands = filters.brands.map(brand => {
                if(brand.Name === filter.name){
                    brand.active = false;
                    brand.checked = false;
                }
                return brand
            })

            const _brandSelected = filters.brands.filter(brand => brand.active && brand.checked);
            setBrandName(_brandSelected);
            PubSub.dispatch('filter_setBrands', { brands: _brandSelected });
        }

        if(type === 'specification') {
            specificationSelected = specificationSelected.map(item => {
                if(item.Name === filter.name){
                    item.active = false;
                    item.checked = false;
                }
                return item;
            });
        }

        const _specificationSelected = specificationSelected.filter(item => item.active && item.checked);
        setSpecificationName(_specificationSelected);
        PubSub.dispatch('filter_setSpecifications', { specifications: _specificationSelected});

    }

    const applyBtn = () => {
        PubSub.dispatch('catalog_toogleFilter', false);

        const _brands = filters.brands.filter(item => {
            return item.checked;
        })

        setBrandName(_brands.map(item => {return {name: item.Name}}));

        const filtersData = filters.filtersSearch || filters.filters;
        const _specifications = Object.keys(filtersData).reduce((acumulator, specification) =>  {
            return acumulator.concat(filtersData[specification].filter(item => item.checked))
        },[])

        setSpecificationName(_specifications.map(item => ({name: item.Name})));

        TagManagerService.filterMenu('Aplicar filtros', brandName, 'Menú Lateral');

        PubSub.dispatch('filter_setBrands', { brands: _brands || [] });
        PubSub.dispatch('filter_setSpecifications', { specifications: _specifications || [] });

    }

    const verifyBtn = () => {
        const _brands = filters.brands.filter(item => {
            return (item.checked && !item.active) || (!item.checked && item.active);
        })

        const _specifications = specificationSelected.filter(item => {
            return (item.checked && !item.active)  || (!item.checked && item.active);
        })

        setSelectedFilters(_brands.length > 0 || _specifications.length > 0);
    }

    useEffect(() => {
        if(filters) {

            if(filters.brands){
                setBrandName(filters.brands.filter(item => item.active).map(item => ({name: item.Name})))
            }

            if(filters.filtersSearch){
                applyInitSpecification(filters.filtersSearch)
            }
            if(filters.filters && !filters.filtersSearch){
                applyInitSpecification(filters.filters, false);
            }
            if(!(filters.filtersSearch && Object.keys(filters.filtersSearch).length) && !(filters.filters && Object.keys(filters.filters).length)){
                specificationSelected = []
            }
        }

    }, [filters])

    const applyInitSpecification = (objetFilters, isSearch = true) => {
        let _FiltersApplyed = [];
        let filSearch = getFiltersSearch(objetFilters, isSearch);

        if(filSearch){
            filSearch.forEach((filter) => {
                _FiltersApplyed = _FiltersApplyed.concat(filter.items.filter(item => item.active));
            });
            specificationSelected = _FiltersApplyed
        }
    }

    useEffect(() => {
        setSpecificationName(specificationSelected.filter(item => item.active).map(item => ({name: item.Name})))

    }, [specificationSelected])


    const filtersSearch = getFiltersSearch(filters.filtersSearch);

    return(
        <div className="catalog-aside-wrapper">
            {filters && <div className={'catalog-aside' + (isFilterOpened ? " open" : "")}>
                <div className="catalog-aside-container">
                    {filters.categories && filters.categories.length > 0 && <CategoriesList category={filters.categories[0]} />}
                    <div className="filter-apply-title-container">
                        <h4 className="category-aside-title">{(!!brandName.length || !!specificationName.length) ? 'Filtros aplicados' : 'Filtros'}</h4>
                        {!!(brandName.length || specificationName.length) && <span className="filters-apply-delete" onClick={cleanFilters}>Borrar filtros</span>}
                    </div>
                    <div className="filter-applying-container">
                        {brandName && brandName.map((brand, i) => {
                            return (
                                <span className ="filter-applying" onClick={(event) => cleanFilter(event, brand, 'brand')} key={i}>
                                    {brand.name}
                                    <button className="filter-apply-delete"/>
                                </span>
                            )
                        })}
                        {specificationName && specificationName.map((specification, i) => {
                            return (
                                <span className ="filter-applying" onClick={(event) => cleanFilter(event, specification, 'specification')} key={i}>
                                    {specification.name}
                                    <button className="filter-apply-delete"/>
                                </span>
                            )
                        })}
                    </div>
                    <Brands brands={filters.brands} filter={props.filter}/>
                    {filters.filters && Object.keys(filters.filters).map((specifications, i) => {
                        const idSpecification = filters.filters[specifications] && filters.filters[specifications][0] ? filters.filters[specifications][0].Map.split('_')[1] : '';
                        return filters.filters && filters.filters[specifications] ? <Specification items={filters.filters[specifications]} title={specifications} id={idSpecification} key={i} filter={props.filter}/> : ''
                    })}
                    {filtersSearch && filtersSearch.map((specification) => <Specification items={specification.items} title={specification.name} id={specification.name} key={specification.name} filter={props.filter}/>)}
                </div>
                <div className={'catalog-aside-buttons'}>
                    <button className="catalog-aside-btn-clean" onClick={closeFilter}>Cerrar</button>
                    <button className={"catalog-aside-btn-apply primary-btn" + (selectedFilters ? '' : ' disabled')} onClick={applyBtn}>Aplicar</button>
                </div>
            </div>}
            <span className={"catalog-aside-bg"+ (isFilterOpened ? " active" : "")} onClick={closeFilter}/>
        </div>
    )
}

Sidebar.propTypes = {
    filters: PropTypes.object,
    specifications: PropTypes.array,
    filter: PropTypes.object

};

export default Sidebar;
